module.exports = __webpack_public_path__ + "static/media/broker-team-mobile.ad85cce0.jpg";